import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Firebase configuration
// Replace these values with your actual Firebase project configuration
const firebaseConfig = {
    apiKey: "AIzaSyA0z9mIqH-sZQWfRJeIlgouq3bh8IYgVN4",
    authDomain: "trezo-99346.firebaseapp.com",
    projectId: "trezo-99346",
    storageBucket: "trezo-99346.firebasestorage.app",
    messagingSenderId: "1096852386296",
    appId: "1:1096852386296:web:c5f70e26653a24fdc6660d",
    measurementId: "G-B256ELD3V8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging and get a reference to the service
export const messaging = getMessaging(app);

// VAPID key for push notifications
// Replace with your actual VAPID key from Firebase Console > Project Settings > Cloud Messaging
const VAPID_KEY = "BKT8Q7zpf16raZO1BVYOnRTQ1csL1QWFi9acNCJjRetKW6Ex9zkMZEydM59CTQhzHvAMQ5OsNrUokP2U21jRg5E";

// Request permission and get FCM token
export const requestPermission = async (): Promise<string | null> => {
  try {
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      console.log('Notification permission granted.');
      
      // Get registration token
      const token = await getToken(messaging, { vapidKey: VAPID_KEY });
      
      if (token) {
        console.log('FCM registration token:', token);
        return token;
      } else {
        console.log('No registration token available.');
        return null;
      }
    } else {
      console.log('Unable to get permission to notify.');
      return null;
    }
  } catch (error) {
    console.error('An error occurred while retrieving token:', error);
    return null;
  }
};

// Listen for foreground messages
export const onMessageListener = () => {
  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log('Message received in foreground:', payload);
      resolve(payload);
    });
  });
};

// Set up continuous foreground message listener
let isListenerSetup = false;
export const setupForegroundListener = (callback: (payload: any) => void) => {
  if (isListenerSetup) {
    console.log('Firebase foreground listener already set up, skipping...');
    return;
  }
  
  console.log('Setting up Firebase foreground message listener...');
  onMessage(messaging, (payload) => {
    console.log('Message received in foreground:', payload);
    callback(payload);
  });
  isListenerSetup = true;
  console.log('Firebase foreground message listener registered');
};

export default app;
